import React, { useState } from "react";
import axios from "axios";

import Cookies from "js-cookie";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import { Lock, Email } from "@material-ui/icons";
import { Typography, Grid, TextField, Button } from "@material-ui/core";
import Image1 from "react-bootstrap/Image";

import AuthContext from "../components/auth-context";
import sambaposLogo from "../images/sambapos.png";
import getirLogo from "../images/getir.png";

const useStyles = makeStyles(() => ({
  mainContainer: {
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    "& input": {
      "&:-webkit-autofill": {
        transition:
          "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
      },
      "&:-webkit-autofill:focus": {
        transition:
          "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
      },
      "&:-webkit-autofill:hover": {
        transition:
          "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
      },
    },
  },
  textField: {
    width: 240,
    backgroundColor: "#d3d3d3",
  },

  typography: {
    color: "tomato",
    fontSize: 35,
    fontWeight: 800,
    fontFamily: "ui-monospace",
  },
  label: {
    fontSize: 13,
  },
  inputContainer: {
    justifyContent: "center",
  },
}));

const Login = () => {
  const Auth = React.useContext(AuthContext);
  const classes = useStyles();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [state, setState] = React.useState({
    checkedA: false,
  });

  const emailChange = (e) => {
    e.preventDefault();
    setEmail(e.target.value);
  };
  const passChange = (e) => {
    e.preventDefault();
    setPassword(e.target.value);
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const login = (e) => {
    e.preventDefault();
    let request = {
      email,
      password,
    };
    axios
      .post("https://getirs2.sambapos.com/auth/login", request)
      .then((resp) => {
        if (state.checkedA === true) {
          let loginToken = resp.data.token;
          let loginInfo = resp.data.userInfo;
          Cookies.set("sambauser", loginToken, { expires: 30 });
          localStorage.setItem("login", JSON.stringify(loginInfo));
          Auth.setLoggedIn(true);
        } else {
          let loginToken = resp.data.token;
          let loginInfo = resp.data.userInfo;
          Cookies.set("sambauser", loginToken);
          localStorage.setItem("login", JSON.stringify(loginInfo));
          Auth.setLoggedIn(true);
        }
      })
      .catch((err) => {
        setError(err.response.data.error);
      });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      login(event);
    }
  };

  return (
    <Grid
      container
      className={classes.mainContainer}
      style={{ height: 85 + "vh" }}
    >
      <Grid
        container
        item
        xs={4}
        spacing={2}
        style={{ justifyContent: "center" }}
      >
        <Grid item xs={"auto"}></Grid>
        <Grid
          item
          xs={9}
          style={{ alignSelf: "flex-end", textAlign: "center" }}
        >
          <Image1 src={sambaposLogo} fluid />
          <Image1 src={getirLogo} style={{ height: 40, width: 100 }} fluid />
        </Grid>
        <Grid item xs={"auto"}></Grid>
      </Grid>
      <Grid
        container
        item
        xs={6}
        spacing={2}
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          marginTop: 5,
        }}
      >
        <Grid item xs={6}>
          <Grid>
            <Grid
              container
              spacing={1}
              alignItems="flex-end"
              className={classes.inputContainer}
            >
              <Grid item>
                <Email />
              </Grid>
              <Grid item>
                <TextField
                  id="input-with-icon-grid1"
                  label="E-posta"
                  onChange={emailChange}
                  className={classes.textField}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={1}
              alignItems="flex-end"
              className={classes.inputContainer}
            >
              <Grid item>
                <Lock />
              </Grid>
              <Grid item>
                <TextField
                  type="password"
                  className={classes.textField}
                  id="input-with-icon-grid"
                  label="Şifre"
                  onKeyPress={(event) => handleKeyPress(event)}
                  onChange={passChange}
                />
              </Grid>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      checked={state.checkedA}
                      onChange={handleChange}
                      name="checkedA"
                      style={{ marginLeft: 160, paddingRight: 2 }}
                    />
                  }
                  label="Beni Hatırla"
                  classes={{ label: classes.label }}
                />
              </div>
            </Grid>
          </Grid>

          <Button
            color="primary"
            fullWidth={true}
            style={{
              color: "#fff",
              backgroundColor: "tomato",
              borderRadius: 8,
            }}
            onClick={(e) => login(e)}
          >
            GİRİŞ
          </Button>
        </Grid>
        <br />
        <Grid>
          <Typography style={{ textAlign: "center" }} color="error">
            {error}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Login;
